import cn from 'classnames';
import { Typography } from 'seagull';
import { chartColors } from "../chartColors";
import WithLegendDot from "../WithLegendDot/WithLegendDot";
import styles from "./CustomTooltip.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders a tooltip to be used in recharts graphs using the recharts Tooltip component
 * with "content" prop.
 */
export default function CustomTooltip(props) {
  const {
    active,
    payload,
    label,
    testId,
    getItems,
    getTitle,
    getBody
  } = props;
  const isDark = props.skin === 'dark';
  const hasRelevantPayload = payload === null || payload === void 0 ? void 0 : payload.some(p => !!p.value);
  const title = getTitle ? getTitle(label, payload) : label;
  const items = getItems(payload === null || payload === void 0 ? void 0 : payload.filter(p => p.value)) || [];
  return active && hasRelevantPayload && items.length > 0 ? /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, isDark && styles.dark),
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      skin: isDark ? 'invertedStandard' : 'secondary',
      weight: isDark ? 'bold' : 'light',
      testId: testId && "".concat(testId, "-title"),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.separator
    }), getBody && /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph2",
      skin: isDark ? 'invertedStandard' : 'standard',
      testId: testId && "".concat(testId, "-body"),
      children: getBody(payload)
    }), items.map((_ref, idx) => {
      let {
        id,
        label,
        color,
        dataKey,
        inBrackets
      } = _ref;
      return /*#__PURE__*/_jsx(WithLegendDot, {
        color: color || chartColors.lightGray,
        testId: testId && "".concat(testId, "-item-").concat(idx),
        "data-key": dataKey,
        children: /*#__PURE__*/_jsxs(Typography, {
          variant: "paragraph2",
          skin: isDark ? 'invertedStandard' : 'standard',
          children: [label, inBrackets && /*#__PURE__*/_jsxs(Typography, {
            as: "span",
            variant: "paragraph2",
            skin: "secondary",
            children: [' ', "(", inBrackets, ")"]
          })]
        })
      }, id);
    })]
  }) : null;
}